<template>
  <div class="inputs-block">
    <div class="row">
      <div class=" col-lg-6 col-sm-12 col-xs-12 text-log-line">
        <h1 class="header">{{ 'Events with External Impact' | i18n }}</h1>
      </div>
      <div class=" col-lg-5 col-sm-12 col-xs-12 input-log-line"></div>
    </div>
    <div class="row input-line align-items-center" v-for="v in values" :key="v.name">
      <div class=" col-lg-3 col-sm-12 col-xs-12 text-log-line d-flex align-items-center">
        {{ v.name | i18n }}
      </div>
      <div class=" col-lg-4 col-sm-12 col-xs-12 input-log-line">
        <Radio
          v-model="value[v.name].value"
          :viewMode="!isMyTeam"
          :options="options"
          :formGroupId="v.name + 'select'"
        />
      </div>
      <div class=" col-lg-5 col-sm-12 col-xs-12 input-log-line">
        <Input v-model="value[v.name].comment" :viewMode="!isMyTeam" placeholder="Comments" :formGroupId="v.name" />
      </div>
    </div>
    <div class="row input-line">
      <div class=" col-lg-3 col-sm-12 col-xs-12 text-log-line d-flex align-items-center">
        {{ 'Comment' | i18n }}
      </div>
      <div class=" col-lg-9 col-sm-12 col-xs-12 input-log-line">
        <Textarea
          v-model="value['Comment'].value"
          :viewMode="!isMyTeam"
          placeholder="Comment"
          formGroupId="Comment"
          rows="2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BlockHeader from '../../../../common/block-header';
import Radio from '../../../../common/radio';
import Input from '../../../../common/input';
import Textarea from '../../../../common/textarea';

export default {
  title: 'Events external impact',
  components: { BlockHeader, Radio, Input, Textarea },
  props: {
    isMyTeam: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      values: [
        { name: 'Ambulance Service' },
        { name: 'Fire Brigade Service' },
        { name: 'Police Service' },
        { name: 'Emission Incident' },
        { name: 'Emission Limit Violation Incident' }
      ],
      options: [
        { value: 'Yes', text: this.$translate('Yes') },
        { value: 'No', text: this.$translate('No') }
      ]
    };
  },
  created() {
    this.values.forEach(v => {
      if (!this.value[v.name]) {
        this.value[v.name] = {
          value: null,
          comment: ''
        };
      }
    });
    if (!this.value['Comment']) {
      this.value['Comment'] = {
        value: ''
      };
    }
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.header {
  color: #5f5f5f !important;
  font-size: 1.6rem !important;
  font-weight: 400;
  text-transform: uppercase;
  margin: 0;
}
.height100 {
  height: 100%;
}
.inputs-block {
  margin-bottom: 50px;
}
.input-line {
  padding: 10px 0;
  margin: 10px 0;
  box-shadow: 0px 0px 8px 0px rgba(34, 60, 80, 0.2);
  .form-group {
    margin-bottom: 0px;
  }
}
</style>
